import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InfoIcon from '@mui/icons-material/Info';

const LINKS = [
	{ to: '/home', label: 'Accueil', icon: HomeIcon },
	{ to: '/new-resultats-equipes', label: 'Résultats', icon: EmojiEventsIcon },
	{ to: '/about', label: 'À propos', icon: InfoIcon },
];

function AppNav() {
	const location = useLocation();

	return (
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', py: 1, borderBottom: 1, borderColor: 'divider' }}>
			{LINKS.map(({ to, label, icon: Icon }) => (
				<Button
					key={to}
					component={RouterLink}
					to={to}
					variant={location.pathname === to ? 'contained' : 'text'}
					startIcon={<Icon />}
					size="small"
				>
					{label}
				</Button>
			))}
		</Box>
	);
}

export default AppNav;
